import { render, staticRenderFns } from "./TicketView.vue?vue&type=template&id=1a27ed50&"
import script from "./TicketView.vue?vue&type=script&lang=ts&"
export * from "./TicketView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports